import React from 'react';
import './uploadIntroduction.scss';
import { lang } from '@umu/ukit-lang';
import { DownloadDataMap, DownloadType, ILabelProps } from '../../interface';

interface IProps {
    userId?: string;
    showType?: string;
    label: ILabelProps;
    failedNumber: number;
    children?: JSX.Element;
    isHiddenNotes?: boolean;
    uploadFile: VoidFunction;
    customNotes?: JSX.Element;
    downloadDataMap: DownloadDataMap;
    downFile: (type: DownloadType) => void;
}

function UploadIntroduction(props: IProps) {
    const { label, children, isHiddenNotes = false, uploadFile, downFile, downloadDataMap, customNotes } = props;
    const { label1, label2, label3, label4 } = label;

    const renderNotes = () => {
        if (isHiddenNotes) {
            return;
        }
        if (customNotes) {
            return customNotes;
        }
        return (
            <>
                <div className="tip-title first-span">{lang('注意事项：')}</div>
                <div className="tip-label">{lang('- Excel 数据量较大时，导入过程可能比较缓慢，请耐心等待。')}</div>
                {}

                {}
                <div className="tip-label">
                    {lang('- 如有问题，请联系您的客户成功经理，或通过发送邮件到support@umu.com联系我们。')}
                </div>
                {}
            </>
        );
    };

    return (
        <div className="upload-introduction">
            <>
                <div className="title">{lang('使用前，请阅读以下信息：')}</div>
                <div className="description first-span">{label1}</div>
                <div className="description">
                    {label2}
                    <span
                        className="download-btn"
                        onClick={() => {
                            downFile(DownloadType.importTemplate);
                        }}
                    >
                        {lang('点击下载模板')}
                    </span>
                </div>
                <div className="description">
                    {label3}
                    <span className="download-btn" onClick={uploadFile}>
                        {lang('上传Excel文件')}
                    </span>
                </div>
                <div className="description">
                    {label4}
                    {downloadDataMap[DownloadType.exportExcel] ? (
                        <span
                            className="download-btn"
                            onClick={() => {
                                downFile(DownloadType.exportExcel);
                            }}
                        >
                            {lang('导出Excel文件')}
                        </span>
                    ) : null}
                </div>
                {renderNotes()}
                <div className="modal-label">{lang('模板内容示例：')}</div>

                {children}
            </>
        </div>
    );
}

export default UploadIntroduction;
